// extracted by mini-css-extract-plugin
export default {"fullscreenLoader":"FullscreenLoader_fullscreenLoader__D3Eo6"};